/* Field labels */
export const CODE_INPUT_LABEL = 'Enter redemption code'
export const COMPANY_INPUT_LABEL = 'Company (optional)'
export const FIRST_NAME_INPUT_LABEL = 'First name'
export const LAST_NAME_INPUT_LABEL = 'Last name'
export const FACEPLATE_INPUT_LABEL = 'Choose a card style'

/* Button text */
export const REDEEM_BUTTON_TEXT = 'Redeem your card'
export const EXCHANGE_BUTTON_TEXT = 'Get a plastic card'
export const PRINT_BUTTON_TEXT = 'Print virtual card'
export const REDEEM_BUTTON_VIRTUAL_VISA_TEXT = 'View virtual visa'
export const HELP_CENTER_TEXT = 'Help center'
export const FAQ_TEXT = 'Read FAQs'
export const CHATBOT_TEXT = 'Chat now'
export const FAQ_BODY_TEXT = 'Browse our list of frequently asked questions.'

/* Field errors */
export const FIELD_ERROR_FACEPLATE_REQUIRED = 'Please choose a card style.'
export const FIELD_ERROR_CODE_NUMBER_INVALID = 'Code must be a 4-digit number'

/* Form errors */
export const GENERAL_ERROR = 'There was a problem with your request'
export const ERROR_TEXT_RECAPTCHA_INVALID =
    'Unproccesable request, Invalid captcha code'

/* Alerts */
export const ADDRESS_CANNOT_BE_VERIFIED =
    'Your address could not be verified. Please go back and correct it, or delivery may be impossible.'
